(function () {
  // How long the error banner stays on screen before auto-hiding.
  var ERROR_DURATION_MS = 13000;

  /**
   * Full-screen red/orange flash. One overlay is created lazily and
   * reused for the whole page (not one per section), appended to
   * <body> so it can cover the entire viewport regardless of where
   * the calculator sits in the page.
   */
  function getFlashOverlay() {
    var overlay = document.querySelector('.puc-screen-flash');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'puc-screen-flash';
      overlay.setAttribute('aria-hidden', 'true');
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  var flashTimeout;
  function triggerScreenFlash() {
    var overlay = getFlashOverlay();
    overlay.classList.remove('is-flashing');
    void overlay.offsetWidth;
    overlay.classList.add('is-flashing');

    clearTimeout(flashTimeout);
    flashTimeout = setTimeout(function () {
      overlay.classList.remove('is-flashing');
    }, 700);
  }

  var screenShakeTimeout;
  function triggerScreenShake() {
    var target = document.body;
    if (!target) return;
    target.classList.remove('puc-screen-shake');
    void target.offsetWidth;
    target.classList.add('puc-screen-shake');

    clearTimeout(screenShakeTimeout);
    screenShakeTimeout = setTimeout(function () {
      target.classList.remove('puc-screen-shake');
    }, 600);
  }

  function triggerVibration() {
    // Android Chrome/Firefox support this; iOS Safari does not expose
    // navigator.vibrate at all, so it quietly no-ops there and the
    // shake/flash carry the feedback instead.
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate([120, 60, 120]);
    }
  }

  function initSection(sectionId) {
    var root = document.getElementById(sectionId);
    if (!root || root.dataset.pucInitialized === 'true') return;
    root.dataset.pucInitialized = 'true';

    // Meter total is always budgetHigh (9600W / 40A). budgetLow (7200W / 30A)
    // is the enforced budget while in 30A mode — going over it switches all
    // devices off (see the device-toggle handler below).
    var budgetLow = parseFloat(root.dataset.budgetLow) || 0;
    var budgetHigh = parseFloat(root.dataset.budgetHigh) || 1;
    var budgetHighLabel = root.dataset.budgetHighLabel || (budgetHigh + ' Watts');
    var currentBudget = budgetHigh;

    // Tier toggle: 'low' = 30A model, budget enforced at 7200W; 'high' = 40A
    // model, budget enforced at 9600W. The gauge's 0–9600W scale never
    // changes — only which point on it is the enforced limit. Moving
    // between the two is always a manual switch on the toggle; it never
    // happens automatically.
    var tier = (budgetLow > 0 && budgetLow < budgetHigh) ? 'low' : 'high';
    var budgetToggle = root.querySelector('[data-puc-budget-toggle]');
    var budgetToggleWrap = budgetToggle ? budgetToggle.closest('.puc-budget-toggle') : null;
    var tierBtnLow = root.querySelector('[data-puc-tier-btn="low"]');
    var tierBtnHigh = root.querySelector('[data-puc-tier-btn="high"]');

    var needle = root.querySelector('[data-puc-needle]');

    var deviceGroups = {};
    Array.prototype.slice.call(root.querySelectorAll('[data-puc-device]')).forEach(function (row) {
      var id = row.dataset.deviceId;
      if (!id) return;
      if (!deviceGroups[id]) {
        deviceGroups[id] = { watt: parseFloat(row.dataset.watt) || 0, rows: [] };
      }
      deviceGroups[id].rows.push(row);
    });

    function getDeviceName(row) {
      var nameEl = row.querySelector('.puc-device-name');
      return nameEl ? nameEl.textContent.trim() : '';
    }

    function compareDeviceNames(a, b) {
      return getDeviceName(a).localeCompare(getDeviceName(b), undefined, {
        sensitivity: 'base',
        numeric: true,
      });
    }

    function sortRowsWithin(container) {
      if (!container) return;
      var rows = Array.prototype.filter.call(container.children, function (el) {
        return el.matches && el.matches('[data-puc-device]');
      });
      rows.sort(compareDeviceNames);
      rows.forEach(function (row) { container.appendChild(row); });
    }

    function sortDesktopColumns() {
      var leftCol = root.querySelector('[data-puc-column="left"]');
      var rightCol = root.querySelector('[data-puc-column="right"]');
      if (!leftCol || !rightCol) return;

      var rows = Array.prototype.slice
        .call(leftCol.querySelectorAll('[data-puc-device]'))
        .concat(Array.prototype.slice.call(rightCol.querySelectorAll('[data-puc-device]')));

      rows.sort(compareDeviceNames);

      var splitAt = Math.ceil(rows.length / 2);
      rows.forEach(function (row, index) {
        (index < splitAt ? leftCol : rightCol).appendChild(row);
      });
    }

    sortDesktopColumns();
    root.querySelectorAll('.puc-category-body').forEach(sortRowsWithin);

    function getRowFor(toggle) {
      return toggle.closest('[data-puc-device]');
    }

    function isDeviceChecked(id) {
      var group = deviceGroups[id];
      if (!group || !group.rows.length) return false;
      var toggle = group.rows[0].querySelector('[data-puc-toggle]');
      return !!(toggle && toggle.checked);
    }

    function setDeviceChecked(id, checked) {
      var group = deviceGroups[id];
      if (!group) return;
      group.rows.forEach(function (row) {
        var toggle = row.querySelector('[data-puc-toggle]');
        if (toggle) toggle.checked = checked;
      });
    }

    function resetAllDevices() {
      Object.keys(deviceGroups).forEach(function (id) {
        setDeviceChecked(id, false);
      });
    }

    function currentSumWatts(excludeId, forceState) {
      var sum = 0;
      Object.keys(deviceGroups).forEach(function (id) {
        var isOn = isDeviceChecked(id);
        if (excludeId && id === excludeId) isOn = forceState;
        if (isOn) sum += deviceGroups[id].watt;
      });
      return sum;
    }

    function updateCategoryTotals() {
      root.querySelectorAll('[data-puc-category]').forEach(function (categoryEl) {
        var sum = 0;
        categoryEl.querySelectorAll('[data-puc-device]').forEach(function (row) {
          var toggle = row.querySelector('[data-puc-toggle]');
          if (toggle && toggle.checked) {
            sum += parseFloat(row.dataset.watt) || 0;
          }
        });
        var wattEl = categoryEl.querySelector('[data-puc-category-watt]');
        if (wattEl) {
          wattEl.textContent = formatWatts(sum) + ' Watts active';
        }
      });
    }

    // Small helper so a banner can show a message, auto-scroll to whichever
    // copy of it is visible (desktop/mobile), and auto-hide itself after
    // ERROR_DURATION_MS.
    function createBanner(selector, textSelector) {
      var banners = Array.prototype.slice.call(root.querySelectorAll(selector));
      var hideTimeout;

      function getVisible() {
        for (var i = 0; i < banners.length; i++) {
          if (banners[i].offsetParent !== null) return banners[i];
        }
        return banners[0] || null;
      }

      function show(message) {
        if (!banners.length) return;

        banners.forEach(function (banner) {
          var textEl = banner.querySelector(textSelector);
          if (textEl) textEl.textContent = message;
          banner.hidden = false;
        });

        var visible = getVisible();
        if (visible) {
          requestAnimationFrame(function () {
            visible.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
        }

        clearTimeout(hideTimeout);
        hideTimeout = setTimeout(function () {
          banners.forEach(function (banner) { banner.hidden = true; });
        }, ERROR_DURATION_MS);
      }

      function hide() {
        clearTimeout(hideTimeout);
        banners.forEach(function (banner) { banner.hidden = true; });
      }

      return { show: show, hide: hide };
    }

    var errorBanner = createBanner('[data-puc-error]', '[data-puc-error-text]');

    function triggerRowShake(row) {
      if (!row) return;
      row.classList.remove('puc-shake');
      void row.offsetWidth;
      row.classList.add('puc-shake');

      clearTimeout(root._pucShakeTimeout);
      root._pucShakeTimeout = setTimeout(function () {
        row.classList.remove('puc-shake');
      }, 500);
    }

    function formatWatts(watts) {
      return Math.round(watts).toLocaleString();
    }

    // --- Tier toggle ------------------------------------------------------

    var svgEl = root.querySelector('[data-puc-gauge-svg]');
    var segGroup = root.querySelector('[data-puc-segments]');
    var arcGradient = root.querySelector('[data-puc-arc-gradient]');
    var SEG_COUNT = 60;
    var segPaths = [];

    function buildSegments() {
      if (!svgEl || !segGroup) return;
      var cx = parseFloat(svgEl.dataset.cx), cy = parseFloat(svgEl.dataset.cy);
      var ro = parseFloat(svgEl.dataset.rOuter), ri = parseFloat(svgEl.dataset.rInner);
      var step = 180 / SEG_COUNT;
      function pt(r, deg) {
        var rad = deg * Math.PI / 180;
        return (cx + r * Math.sin(rad)).toFixed(2) + ' ' + (cy - r * Math.cos(rad)).toFixed(2);
      }
      var ns = 'http://www.w3.org/2000/svg';
      segGroup.innerHTML = '';
      segPaths = [];
      for (var i = 0; i < SEG_COUNT; i++) {
        var a0 = -90 + i * step, a1 = a0 + step;
        var path = document.createElementNS(ns, 'path');
        path.setAttribute('d',
          'M ' + pt(ro, a0) + ' A ' + ro + ' ' + ro + ' 0 0 1 ' + pt(ro, a1) +
          ' L ' + pt(ri, a1) + ' A ' + ri + ' ' + ri + ' 0 0 0 ' + pt(ri, a0) + ' Z');
        if (arcGradient) path.setAttribute('fill', 'url(#' + arcGradient.id + ')');
        path.setAttribute('stroke', 'var(--puc-meter-bg, #fff)');
        path.setAttribute('stroke-width', '0.5');
        path.setAttribute('stroke-opacity', '0.55');
        segGroup.appendChild(path);
        segPaths.push(path);
      }
    }

    // 7200W mode: the gradient is squeezed so it ends at the indicator.
    // 9600W mode: it spans the whole arc.
    function updateArcGradient() {
      if (!arcGradient) return;
      var x2 = 271;
      if (tier === 'low' && budgetLow > 0 && budgetLow < budgetHigh) {
        var theta = -Math.PI / 2 + Math.PI * (budgetLow / budgetHigh);
        x2 = 150 + 121 * Math.sin(theta);
      }
      arcGradient.setAttribute('x2', x2.toFixed(2));
    }
    buildSegments();

    function setTier(next) {
      tier = next;
      var isHigh = tier === 'high';
      root.setAttribute('data-tier', tier);
      updateArcGradient();
      // Solid colour segment only exists in 7200W mode (also set inline so it
      // doesn't depend on the stylesheet).
      root.querySelectorAll('.puc-limit-solid').forEach(function (el) {
        el.style.display = isHigh ? 'none' : '';
      });
      if (budgetToggle) budgetToggle.checked = isHigh;
      if (budgetToggleWrap) budgetToggleWrap.setAttribute('data-state', tier);
      if (tierBtnLow) {
        tierBtnLow.classList.toggle('is-active', !isHigh);
        tierBtnLow.setAttribute('aria-pressed', String(!isHigh));
      }
      if (tierBtnHigh) {
        tierBtnHigh.classList.toggle('is-active', isHigh);
        tierBtnHigh.setAttribute('aria-pressed', String(isHigh));
      }
    }

    // The two buttons are the actual UI; they just drive the same hidden
    // checkbox + change event the rest of the logic below already expects.
    function selectTier(next) {
      if (!budgetToggle) return;
      var isHigh = next === 'high';
      if (budgetToggle.checked === isHigh) return;
      budgetToggle.checked = isHigh;
      budgetToggle.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (tierBtnLow) tierBtnLow.addEventListener('click', function () { selectTier('low'); });
    if (tierBtnHigh) tierBtnHigh.addEventListener('click', function () { selectTier('high'); });

    if (budgetToggle) {
      budgetToggle.addEventListener('change', function () {
        var goingLow = !budgetToggle.checked;
        setTier(goingLow ? 'low' : 'high');

        // Moving back from 9600W to 7200W while usage is above 7200W:
        // flash + shake and everything is switched off.
        if (goingLow && currentSumWatts() > budgetLow) {
          resetAllDevices();
          errorBanner.show(
            'Switched back to a ' +
              formatWatts(budgetLow) +
              ' Watts supply. All devices have been switched off — please start again.'
          );
          triggerScreenShake();
          triggerScreenFlash();
        } else {
          errorBanner.hide();
        }
        render();
      });
    }

    // --- Meter total label ----------------------------------------------

    root.querySelectorAll('[data-puc-max-watts]').forEach(function (el) {
      el.textContent = budgetHighLabel;
    });

    // --- Rendering --------------------------------------------------------

    function render() {
      var watts = currentSumWatts();
      var percent = Math.max(0, Math.min(1, watts / currentBudget));
      var angle = -90 + percent * 180;

      if (needle) needle.style.transform = 'rotate(' + angle + 'deg)';

      root.querySelectorAll('[data-puc-current-watts]').forEach(function (el) {
        el.textContent = formatWatts(watts);
      });
      root.querySelectorAll('[data-puc-progress-fill]').forEach(function (el) {
        var widthPct = watts > 0 ? Math.max(percent * 100, 1.5) : 0;
        el.style.width = widthPct + '%';
        // Keep the colours fixed to the track (not stretched to the fill).
        el.style.backgroundSize = (widthPct > 0 ? 10000 / widthPct : 100) + '% 100%';
        el.classList.toggle('is-over', watts > currentBudget);
      });

      updateCategoryTotals();
    }

    root.addEventListener('change', function (event) {
      var toggle = event.target.closest('[data-puc-toggle]');
      if (!toggle) return;

      var row = getRowFor(toggle);
      var id = row ? row.dataset.deviceId : null;
      if (!id) return;

      var checked = toggle.checked;
      setDeviceChecked(id, checked);

      if (checked) {
        var prospective = currentSumWatts(id, true);
        var nameEl = row.querySelector('.puc-device-name');
        var name = nameEl ? nameEl.textContent : 'This device';

        // In 7200W (30A) mode the budget to enforce is 7200W; in 9600W
        // (40A) mode it's 9600W. Either way, going over it reverts the
        // device, switches everything off, and shows an error. The tier
        // itself never changes here — moving from 30A to 40A is always a
        // manual step on the toggle above.
        var limit = tier === 'low' ? budgetLow : budgetHigh;

        if (prospective > limit) {
          setDeviceChecked(id, false);
          resetAllDevices();

          var message =
            name +
            ' would push usage above your ' +
            formatWatts(limit) +
            ' Watts budget. All devices have been switched off — please start again.';
          if (tier === 'low') {
            message += ' For more powering options please consider the 40-amp model.';
          }
          errorBanner.show(message);

          triggerScreenShake();
          triggerScreenFlash();
          triggerRowShake(row);
          triggerVibration();

          row.classList.add('is-disabled-target');
          setTimeout(function () { row.classList.remove('is-disabled-target'); }, 900);

          render();
          return;
        }
      }

      errorBanner.hide();
      render();
    });

    setTier(tier);
    render();
  }

  window.PowerUsageCalculator = {
    init: initSection
  };

  document.querySelectorAll('.puc-section').forEach(function (el) {
    initSection(el.id);
  });
})();
